import { HistoricalStats } from './HistoricalStats';
import { IncongruentPortfolios } from './IncongruentPortfolios';
import { NotEnoughCashForWithdrawals } from './NotEnoughCashForWithdrawals';
import { UpcomingWithdrawals } from './UpcomingWithdrawals';

export const stockWidgets = [
    {
        id: 'historical_stats',
        title: 'Historical Stats',
        widget: HistoricalStats,
    },
    {
        id: 'incongruent_portfolios',
        title: 'Incongruent Portfolios',
        widget: IncongruentPortfolios,
    },
    {
        id: 'upcoming_withdrawals',
        title: 'Withdrawals',
        widget: UpcomingWithdrawals,
    },
    {
        id: 'not_enough_cash_for_withdrawals',
        title: 'Upcoming withdrawals without enough cash',
        widget: NotEnoughCashForWithdrawals,
    },
];
